<template>
<div>
    <div class="boxs">
        <div class="chose-btn flex m-b-14">
            <div class="button" :class="{
                active: type == 1
            }" @click="type = 1">密码登录</div>
            <div class="button"  :class="{
                active: type == 2
            }" @click="type = 2">短信登录</div>
        </div>
        <div v-show="type == 1">
            <div class="input-box m-b-5" :class="{
                error: !!phoneError
            }">
                <input v-model="phone" type="text"  placeholder="请输入您的手机号">
            </div>
            <div class="tips">当前手机已注册，请再输入密码登录</div>
            <div class="input-box m-b-5" :class="{
                error: !!passwordError
            }">
                <input @focus="inputType = 'password'" :type="inputType"  v-model="password" placeholder="请输入登录密码">
            </div>
            <div class="flex flex-between m-b-68">
                <div class="tips error">{{passwordError}}</div>
                <div class="forget" @click="onForget">忘记密码？</div>
            </div>
            <div class="primary-btn m-b-14" @click="goLogin">立即登录/注册</div>
        </div>
        <div v-show="type == 2">
            <div class="input-box m-b-5" :class="{
                error: !!phoneError
            }">
                <input v-model="phone" type="text"  placeholder="请输入您的手机号">
            </div>
            <div class="tips">当前手机已注册，请验证手机登录</div>
            <div class="captcha flex flex-between">
                <div class="input-box" :class="{
                    error: !!captchaError
                }">
                    <input v-model="captcha" type="text"  placeholder="请输入图形验证码">
                </div>
                <div class="captcha-img m-l-10"  @click="captchasrc = '/wapi/base/captcha?'+(new Date).getTime()">
                    <img :src="captchasrc">
                </div>
            </div>
            <div class="tips" :class="{error: captchaError}">{{captchaError}}</div>
            <div class="input-box reg-ms flex" :class="{
                error: !!verifyError
            }">
                <input v-model="verifyCode" type="text"  placeholder="请输入验证码">
                <div class="ms-text flex-shrink" @click="onSend">
                    {{time >= 0 ? '还剩 '+ time +' 秒' : '发送验证码'}}
                </div>
            </div>
            <div class="tips" :class="{error: verifyError}">{{verifyError}}</div>
            <div class="primary-btn m-b-14" @click="goLogin">立即登录/注册</div>
        </div>
    </div>
</div>
</template>
<script>
    const qs = require('qs');
    export default {
        data(){
            return {
                type: 1,
                inputType: 'text',
                password: '',

                phoneError: '',
                captchaError: '',
                verifyError: '',
                passwordError:'',

                time: -1,
                timer: null,

                captchasrc:'/wapi/base/captcha', //图片验证码地址 
                captcha:'', // 图形验证码
                yzmtxt:'发送验证码',// 验证码文字
                phone:'', // 手机号码
                verifyCode:'',// 验证码
                issend:false,

                
            }
        },
        created () {
            this.phone = this.$route.query.phone
        },
        methods:{
            onSend () {
                let time = this.time;
                if(time < 0){
                    const url = '/wapi/hr/getLoginCode?phone=' + this.phone + '&captcha=' + this.captcha;
                    this.axios.get(url)
                        .then(response => {
                            if (response.status * 1 == 200) {
                                this.time = time = 60;
                                this.timer = setInterval(()  => {
                                    this.time = time = time - 1
                                    if (time < 0) {
                                        clearInterval(this.timer)
                                    }
                                }, 1000)
                            }else{
                                this.captchasrc = '/wapi/base/captcha?'+(new Date).getTime()
                            }
                        })
                }
            },
            onForget () {
                this.$router.push({
                    path:'/pwdfindone'
                })
            },
            goLogin(){
                
                const phone = this.phone
                if( phone.length == 0 ){
                    this.phoneError = '请输入手机号';
                    return
                } else if( phone.length != 11 ) {
                    this.phoneError = '手机号格式不正确';
                    return
                } 
                const type = this.type
                let url = '/wapi/hr/login'
                let qdata = {
                    phone: phone,
                    password:this.password
                };
                if ( type == 1 ) {
                    if (!this.password) {
                        this.passwordError = '请输入密码'
                        return
                    }
                } else {
                    url = '/wapi/hr/smsLogin';
                    if (!this.captcha.length) {
                        this.captchaError = '请输入图片验证码';
                        return
                    } else if (!this.verifyCode.length) {
                        this.verifyError = '请输入验证码';
                        return
                    }
                    qdata = {
                        phone: phone,
                        verifyCode :this.verifyCode
                    };
                }
                this.axios.post(url,qs.stringify(qdata))
                .then((res)=>{
                    if(res.status*1 == 200){
                        this.getCompany();
                    }
                })
            },
            yzmfs(){
                if(this.issend){
                    return;
                }
                if(this.phone.length == 0){
                    this.$message({
                        type:'warning',
                        message:'请输入手机号码'
                    });
                    return;
                }
                if(this.phone.length < 11){
                    this.$message({
                        type:'warning',
                        message:'请输入11位手机号码'
                    });
                    return;
                }
                if(this.captcha.length == 0){
                    this.$message({
                        type:'warning',
                        message:'请输入图片验证码'
                    });
                    return;
                }
                let url = `/wapi/hr/getLoginCode?captcha=${this.captcha}&phone=${this.phone}`;
                this.axios.get(url).then(res => {
                    if(res.success){
                        this.issend = true;
                        this.yzmDjs();
                    }
                })
            },
            yzmDjs(){
                let times = 60;
                this.yzmtxt = times + 's后重新发送';
                let interval = setInterval(()=>{
                    times--;
                    if(times < 0){
                        clearInterval(interval);
                        this.yzmtxt = "发送验证码"
                        this.issend = false;
                    }else{
                        this.yzmtxt = times + 's后重新发送';
                    }
                },1000);
            },
            goregister(){
                this.$router.push({path:'/register/step_one'})
            },
            getCompany(){
                this.axios.get("/wapi/hr/listCompany").then(res =>{
                    if(res.status*1 == 200){
                        if(res.data && res.data.length == 0){
                            this.$router.push({path:'/register/join'});
                        }else{
                            this.$router.push({path:"/login/select"});
                        }
                    }
                })
            }
        }
    }
</script>
<style scoped lang="less">
@import url('../../assets/less/login.less');
</style>



// WEBPACK FOOTER //
// yzlogin.vue?4026059a